import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

export const YearPicker = ({ value, onChange, onBlur, min = 0, max = 50 }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  const years = Array.from({ length: max - min + 1 }, (_, i) => i + min);

  return (
    <div className="relative">
      <div 
        className="flex items-center justify-between border rounded-lg border-gray-100 px-3 py-2 cursor-pointer bg-white"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="text-gray-700">{value ? `${value} Year${parseInt(value) !== 1 ? 's' : ''}` : 'Select Years'}</span>
        {isOpen ? (
          <ChevronUpIcon className="h-4 w-4 text-gray-500" />
        ) : (
          <ChevronDownIcon className="h-4 w-4 text-gray-500" />
        )}
      </div>
      
      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-100 rounded-lg shadow-lg max-h-60 overflow-auto">
          <div className="py-1">
            {years.map((year) => (
              <div
                key={year}
                className={`px-4 py-2 cursor-pointer hover:bg-gray-50 ${
                  value === year.toString() ? 'bg-gray-100' : ''
                }`}
                onClick={() => {
                  onChange(year.toString());
                  setIsOpen(false);
                  onBlur();
                }}
              >
                {year} Year{year !== 1 ? 's' : ''}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};


export const MonthPicker = ({ value, onChange, onBlur }) => {
    const [isOpen, setIsOpen] = useState(false);
    
    const months = Array.from({ length: 12 }, (_, i) => i + 1);
  
    return (
      <div className="relative">
        <div 
          className="flex items-center justify-between border rounded-lg border-gray-100 px-3 py-2 cursor-pointer bg-white"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="text-gray-700">{value ? `${value} Month${parseInt(value) !== 1 ? 's' : ''}` : 'Select Months'}</span>
          {isOpen ? (
            <ChevronUpIcon className="h-4 w-4 text-gray-500" />
          ) : (
            <ChevronDownIcon className="h-4 w-4 text-gray-500" />
          )}
        </div>
        
        {isOpen && (
          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-100 rounded-lg shadow-lg max-h-60 overflow-auto">
            <div className="py-1">
              {months.map((month) => (
                <div
                  key={month}
                  className={`px-4 py-2 cursor-pointer hover:bg-gray-50 ${
                    value === month.toString() ? 'bg-gray-100' : ''
                  }`}
                  onClick={() => {
                    onChange(month.toString());
                    setIsOpen(false);
                    onBlur();
                  }}
                >
                  {month} Month{month !== 1 ? 's' : ''}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  
